/*----------------------------------------------------------------------------*\
    THROTTLE
    Throttle events
\*----------------------------------------------------------------------------*/

/*  Function
\*----------------------------------------------------------------------------*/

(function() {
    var throttle = function(type, name, obj) {
        obj = obj || window;
        var running = false;
        var func = function() {
            if (running) { return; }
            running = true;
            requestAnimationFrame(function() {
                var e = document.createEvent('Event');
                e.initEvent(name, true, true);
                obj.dispatchEvent(e);
                running = false;
            });
        };
        obj.addEventListener(type, func);
    };

    /**
     * init - you can init any event
     */
    throttle('resize', 'optimizedResize');
})();